module.exports = __webpack_public_path__ + "static/media/partner-store-banner.87153ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-banner.png
// module id = 572
// module chunks = 0